import React from "react";
import { useTranslation } from "react-i18next";

import VerticalMenu from "../../../ui/components/VerticalMenu/VerticalMenu";
import useMenuDocTitle from "../../../ui/hooks/useMenuDocTitle";
import PageView from "../../../ui/views/PageView/PageView";

import useSuperAdminSettingsMenuOptions from "./hooks/useSuperAdminSettingsMenuOptions";

export default function SuperAdminSettingsView(props) {
	const { t } = useTranslation();

	const options = useSuperAdminSettingsMenuOptions();

	useMenuDocTitle(t("settings", "Settings"), options);

	return <PageView header={t("settings", "Settings")} sidebar={<VerticalMenu options={options} />} {...props} />;
}
